function floatingBoxInit() {
    const $box = $('.js-articles-nav'),
        $boxWrapper = $('.js-float-box-wrapper');

    floatingBoxFloat($box, $boxWrapper);

    $(window).on('scroll resize', function() {
        floatingBoxFloat($box, $boxWrapper);
    });
}

function floatingBoxFloat($box, $boxWrapper) {
    if (checkResolution('md;lg')) {
        const windowTopOffset = $(document).scrollTop(),
            boxWrapperTopOffset = $boxWrapper.offset().top,
            boxWrapperHeight = $boxWrapper.outerHeight(),
            boxHegiht = $box.height(),
            scrollOffset = 30,
            // Scroll okna plus offset elementu od vrcho pri scrolle v pixeloch
            boxStartScroll = windowTopOffset + scrollOffset,
            // odsadenie elementu od vrchu plus vyska wrapperu minus vyska floatovacieho okna
            boxEndScroll = boxWrapperTopOffset + boxWrapperHeight - boxHegiht;

        // Ak je scroll okna vacsi ako vrchna pozicia wrapperu floatovacieho boxu
        // a zaroven je scroll okna mensi ako vrchna pozicia wrapperu floatovacieho boxu
        // plus celkova velkost wrapperu floatovacieho okna minus velkost floatovacieho okna
        // vtedy sa prida position fixed
        if (
            boxStartScroll > boxWrapperTopOffset &&
            boxStartScroll < boxEndScroll
        ) {
            if (!$box.hasClass('is-fixed')) {
                $box.css('top', scrollOffset);
                $box.addClass('is-fixed');
            }

            // Ak je scroll okna vacsi ako finalna scrollovacia poziciia vtedy sa floatovaci box
            // posunie uplne na spodok wrapperu
        } else if (boxStartScroll > boxEndScroll) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxEndScroll - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }

            // Ak je scroll okna mensi ako vrchna pozicia wrapper, vtedy sa floatovaci box posunie
            // uplne na vrch wrapperu
        } else if (boxStartScroll < boxWrapperTopOffset) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxWrapperTopOffset - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }
        }
    }
}

function blogGalleryCollapsibleHeightBuild() {
    $('.js-blog-gallery-collapsible').each(function() {
        const $collapsible = $(this),
            $trigger = $collapsible.siblings(
                '.js-blog-gallery-collapsible-trigger'
            ),
            $collapsibleContent = $collapsible.find(
                '.js-blog-gallery-collapsible-content'
            );

        let maxHeight = 325;

        if (checkResolution('cxs;xs')) {
            maxHeight = 250;
        }

        if ($collapsibleContent.outerHeight(true) > maxHeight) {
            if ($trigger.hasClass('open')) {
                $collapsible
                    .addClass('resizing')
                    .css('max-height', $collapsibleContent.outerHeight(true));

                setTimeout(function() {
                    $collapsible.removeClass('resizing');
                }, 1);
            } else {
                $trigger.slideDown(500);
                $collapsible.addClass('collapsed');
            }
        } else {
            $collapsible.removeClass('collapsed');
            $trigger.slideUp(250).removeClass('open');
        }
    });
}

function buildMasonryGrid() {
    if (!$('.l-articles').hasClass('is-blog')) {
        return false;
    }

    $('.c-listing').each(function() {
        if ($(this).hasClass('is-masonry')) {
            return true;
        }

        $(this).append('<div class="grid-sizer"></div>');

        $(this).masonry({
            itemSelector: '.c-listing__item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            transitionDuration: 0,
            gutter: 30,
            horizontalOrder: true,
        });

        $(this).addClass('is-masonry');
    });
}

rEvent.on('Listing.afterFetch', function() {
    buildMasonryGrid();
});

$(function() {
    buildMasonryGrid();

    if ($('.js-float-box-wrapper').length) {
        floatingBoxInit();
    }

    blogGalleryCollapsibleHeightBuild();

    $('.js-blog-gallery-collapsible-trigger').on('click', function() {
        const $trigger = $(this),
            $collapsible = $trigger.siblings('.js-blog-gallery-collapsible'),
            $collapsibleContent = $collapsible.find(
                '.js-blog-gallery-collapsible-content'
            ),
            $galleryWrapper = $collapsible.closest('.js-blog-gallery');

        if ($trigger.hasClass('open')) {
            $trigger.removeClass('open');
            $collapsible.addClass('collapsed').css('max-height', '');

            if ($galleryWrapper.offset().top < $(window).scrollTop()) {
                $galleryWrapper.slideHere(30, 300);
            }
        } else {
            $trigger.addClass('open');
            $collapsible
                .removeClass('collapsed')
                .css('max-height', $collapsibleContent.outerHeight(true));
        }
    });

    $(window).on('resize', function() {
        blogGalleryCollapsibleHeightBuild();
    });

    $('.l-articles').off('click', '.js-articles-menu');

    $('.l-articles').on('click', '.js-articles-menu', function() {
        var $nav = $('.js-articles-nav');

        $nav.slideToggle(250);
    });

    $('body').on('click', '.pager__item:not(.disabled) a', function() {
        $('html, body').animate(
            {
                scrollTop: $('.l-articles')
                    .first()
                    .offset().top,
            },
            400
        );
    });

    //fancybox
    $('[data-fancybox]').fancybox({
        thumbs: {
            autoStart: true,
        },
    });
});
